module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "http://siweitech.b0.upaiyun.com//image/570/siwei.me_header.png"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55ccd29a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Logo.vue
// module id = 65
// module chunks = 0